import type {
	AppState,
	NubeSDKState,
} from "@tiendanube/nube-sdk-internal-types";
import { importApp } from "./code-handler";
import { dispatchError } from "./messages";
import { createWorkerSDK } from "./worker-sdk";

export async function run(
	app: Pick<AppState, "id" | "script">,
	initialState: NubeSDKState,
) {
	const workerSDK = createWorkerSDK(initialState, app.id);
	await importApp(app)
		.then((partner) => {
			if (typeof partner.App !== "function") {
				dispatchError(app.id, "Partner App entrypoint is not a function");
				return;
			}
			partner.App(workerSDK);
		})
		.catch((error) => {
			dispatchError(
				app.id,
				error instanceof Error
					? error.message
					: typeof error === "string"
						? error
						: `unable to register app ${error}`,
			);
		});
}
